/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Duplicate_ConfirmationInputs */

const en_case_payment_validation_duplicate_confirmation = /** @type {(inputs: Case_Payment_Validation_Duplicate_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A payment cannot be confirmed more than once.`)
};

const pt_br2_case_payment_validation_duplicate_confirmation = /** @type {(inputs: Case_Payment_Validation_Duplicate_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um pagamento não pode ser confirmado mais de uma vez.`)
};

/**
* | output |
* | --- |
* | "A payment cannot be confirmed more than once." |
*
* @param {Case_Payment_Validation_Duplicate_ConfirmationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_duplicate_confirmation = /** @type {((inputs?: Case_Payment_Validation_Duplicate_ConfirmationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Duplicate_ConfirmationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_duplicate_confirmation(inputs)
	return pt_br2_case_payment_validation_duplicate_confirmation(inputs)
});